import { useAdpAnalytics } from '@profile-ui-mono/utilities/context/AdpAnalyticsProvider';
import { sendLog } from '@profile-ui/shared-components';

/**
 * Generic ADP WebSDK analytics hook.
 * Reusable across all modules (home, settings, personalinfo, etc.).
 *
 * @param {string} moduleName - Module identifier for error logging (e.g., 'Home', 'Settings')
 * @returns {object} Analytics tracking functions
 *
 * @example
 * const { trackAnalytics } = useAnalytics('Home');
 *
 * trackAnalytics({
 *   type: adpAnalyticsEvents.CLICK_COMPONENT,
 *   data: { id: 'home_card', name: 'Card', type: 'Card' },
 * });
 */
const useAnalytics = (moduleName = 'Analytics') => {
  const adp = useAdpAnalytics();

  const trackADP = (eventType, eventData) => {
    if (adp) {
      try {
        adp.track(eventType, eventData);
      } catch (error) {
        sendLog(error, `${moduleName} ADP tracking error`, `useAnalytics::${moduleName}`);
      }
    }
  };

  /**
   * Track an ADP analytics event.
   *
   * @param {object} adpEvent - { type, data } for ADP
   */
  const trackAnalytics = (adpEvent) => {
    if (adpEvent) {
      trackADP(adpEvent.type, adpEvent.data);
    }
  };

  return {
    trackADP,
    trackAnalytics,
  };
};

export default useAnalytics;
